module.exports = __webpack_public_path__ + "img/page7img5.ed03e199.png";